import { render, staticRenderFns } from "./BatteryIcon.vue?vue&type=template&id=2fa11aae&scoped=true&lang=pug"
import script from "./BatteryIcon.vue?vue&type=script&lang=js"
export * from "./BatteryIcon.vue?vue&type=script&lang=js"
import style0 from "./BatteryIcon.vue?vue&type=style&index=0&id=2fa11aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa11aae",
  null
  
)

export default component.exports